import React from 'react'
import List from '../components/products/List'

const Products = () => {

    return(<>
        <List />
    </>)

}


export default Products